import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaHandshake,
  FaGavel,
  FaLaptopCode,
  FaLeaf,
} from "react-icons/fa";

const PracticeAreas = () => {
  const COLORS = {
    bgPrimary: "#0B1C2D",
    bgSecondary: "#13293D",
    gold: "#C6A75E",
    textLight: "#EAEAEA",
  };

  const practices = [
    {
      title: "Civil Matters",
      desc: "Expert handling of property disputes, contracts, and ownership conflicts.",
      icon: <FaBuilding />,
      link: "/services/civil-cases",
    },
    {
      title: "Criminal Law",
      desc: "Strategic defense in bail, trial, and white-collar crimes.",
      icon: <FaGavel />,
      link: "/services/criminal-cases",
    },
    {
      title: "Matrimonial",
      desc: "Confidential support in divorce and child custody.",
      icon: <FaUsers />,
      link: "/services/matrimonial-Cases",
    },
    {
      title: "Commercial",
      desc: "Business advisory and regulatory compliance.",
      icon: <FaHandshake />,
      link: "/services/commercial-disputes",
    },
    {
      title: "Cyber Law",
      desc: "Protection against fraud and data theft.",
      icon: <FaLaptopCode />,
      link: "/services/cyber-cases",
    },
    {
      title: "Environmental",
      desc: "Compliance and NGT litigation support.",
      icon: <FaLeaf />,
      link: "/services/environmental-matters",
    },
  ];

  return (
    <section className="py-24 px-6 md:px-16 lg:px-32">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="mb-16 text-center">
          <span className="uppercase tracking-widest text-[10px] font-bold block mb-4" style={{ color: COLORS.gold }}>
            Our Specializations
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold leading-tight" style={{ color: "Black" }}>
            Areas of <span className=" font-light opacity-60">Legal</span> Excellence
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {practices.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className="group relative bg-[#13293D] rounded-3xl p-8 md:p-10 flex flex-col justify-between overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Faint background icon */}
              <div
                className="absolute -bottom-6 -right-6 text-7xl opacity-5 group-hover:opacity-10 transition-all duration-500"
                style={{ color: COLORS.gold }}
              >
                {item.icon}
              </div>

              <div className="relative z-10">
                {/* Icon Circle */}
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-xl mb-6 text-2xl transition-all duration-500 group-hover:bg-white/10 border border-white/20"
                  style={{ color: COLORS.gold }}
                >
                  {item.icon}
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold mb-3 text-white">{item.title}</h3>

                {/* Description */}
                <p className="text-gray-400 text-lg leading-relaxed group-hover:text-gray-200 transition-colors">
                  {item.desc}
                </p>
              </div>

              {/* Learn More */}
              <div className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all group-hover:translate-y-0 -translate-y-2 text-[#C6A75E]">
                Learn More <span className="text-lg">→</span>
              </div>

              {/* Hover Top Border */}
              <div
                className="absolute top-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-700"
                style={{ backgroundColor: COLORS.gold }}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;